<div v-if="shouldRenderConfig" v-bind:class="getClassName">
    <div v-bind:class="getClassName + 'PreviewContainer'">        
        <appPreview2D :visible="visibleClass2D"></appPreview2D>
        <appPreview3D :visible="visibleClass3D"></appPreview3D>
    </div>
    <div v-bind:class="getClassName + 'ButtonsContainer'">
        <appPacking3dButtons v-bind:class="visibleClass3D"></appPacking3dButtons>
        <div v-bind:class="getClassName + 'ActionsContainer'">
            <button type="button" @click="togglePreview(false)" class="btn btn-primary" v-bind:class="[getClassName + 'Button', visibleClass2D]">2D</button>
            <button type="button" @click="togglePreview(true)"  class="btn btn-primary" v-bind:class="[getClassName + 'Button', visibleClass3D]">3D</button @click="togglePreview(false)">
        </div>
    </div>
</div>
